module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_sekundærlogo_sentrert_pos.65b5d508.pdf";